<template>
  <div id="app">
    <!-- 主内容区域 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
}

/* 全局修复消息组件被导航栏遮挡的问题 */
.el-message,
.el-message-box,
.el-message-box__wrapper,
.el-notification,
.el-loading-mask {
  z-index: 99999 !important;
}

/* 确保消息框容器也有足够高的层级 */
.el-message-box__wrapper {
  z-index: 99999 !important;
}
</style>
